import { render, staticRenderFns } from "./IpRadioGeneralAdminUserSetting.vue?vue&type=template&id=7a19647a&scoped=true"
import script from "./IpRadioGeneralAdminUserSetting.vue?vue&type=script&lang=js"
export * from "./IpRadioGeneralAdminUserSetting.vue?vue&type=script&lang=js"
import style0 from "./IpRadioGeneralAdminUserSetting.vue?vue&type=style&index=0&id=7a19647a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a19647a",
  null
  
)

export default component.exports